/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vexed_Gross_Jellyfish_RaceInputs */

const fr_vexed_gross_jellyfish_race = /** @type {(inputs: Vexed_Gross_Jellyfish_RaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`séances complétées`)
};

/**

* @param {Vexed_Gross_Jellyfish_RaceInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const vexed_gross_jellyfish_race = /** @type {((inputs?: Vexed_Gross_Jellyfish_RaceInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vexed_Gross_Jellyfish_RaceInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_vexed_gross_jellyfish_race(inputs)
});